// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// Model
import { OrderActivityResponse } from '../dialogs/order-activity/model/order-activity.model';
// Service
import { SystemApiService } from '@cv-invision/core';
// Other
import { Observable } from 'rxjs';

@Injectable()
export class OrderActivityService {
	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService) { }

	/**
	 * Retrieves the activity log for a specific order.
	 *
	 * @param orderId The ID of the order to fetch activity for
	 * @returns An observable containing the activity response data
	 */
	public getOrderActivity(orderId: string): Observable<OrderActivityResponse> {
		const baseUrl = this.systemApiService.api['intelligenceService'];
		return this.httpClient.get<OrderActivityResponse>(
			`${baseUrl}order-details/${orderId}/activity`
		);
	}
}
